module.exports = __webpack_public_path__ + "img/icb-del-novice-e@2x.4874fde1.png";